export const isUserNotLoggedInError = (error: unknown): boolean =>
  typeof error === 'object' && error !== null && 'code' in error && error.code === 'noUserSession';
